<template>
  <div :class="{'has-logo':showLogo}" class="paycools-sidebar">
    <merchant-portrait />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="false"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="(route, index) in permission_routes" :key="(route.path + '_' + index)" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MerchantPortrait from './MerchantPortrait'
import SidebarItem from './SidebarItem'
import variables from '@/styles/paycools/variables.scss'

export default {
  components: { SidebarItem, MerchantPortrait },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    routes() {
      return this.$router.options.routes
    },
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>
<style>
.paycools-sidebar .router-link-active .submenu-title-noDropdown{
  color: rgb(29, 58, 113) !important ;
}
.paycools-sidebar .el-submenu.is-active,
.paycools-sidebar .is-active.submenu-title-noDropdown,
.paycools-sidebar .router-link-active .submenu-title-noDropdown{
  position: relative;
}
.paycools-sidebar .el-submenu.is-active::before,
.paycools-sidebar .is-active.submenu-title-noDropdown::before,
.paycools-sidebar .router-link-active .submenu-title-noDropdown::before{
  position: absolute;
  top: 0;
  left: 0;
  content: '';
  display: inline-block;
  height: 56px;
  width: 7px;
  background: #3855F1;
  border-radius: 0px 4px 4px 0px;
  z-index: 1;
}
</style>
